import { useState, useEffect, useContext, useRef } from "react"
import { currentSearch } from "../contexts/Search";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Loading from "../components/Loading";
import Card from 'react-bootstrap/Card';
import { useParams } from "react-router"
import Filter from "../components/Filter";
import Unauth from '../components/Unauth';
import { CurrentUser } from '../contexts/CurrentUser';

import { renderPagination } from "../components/Pagination";

function ForumPage() {
    const { forumId } = useParams()
    const scrollPanel = useRef();
    const [searchTerm, setSearchTerm] = useState('');
    const { query, setQuery, results: { meta, rows = [] }, isLoading } = useContext(currentSearch);
    const { pages } = meta;
    const firstPost = rows[0]

    useEffect(() => {
        const { current } = scrollPanel || {};
        if (current) {
            current.scrollTop = 0;
        }

    }, [pages, scrollPanel]);


    useEffect(() => {
        const fetchData = async () => {
            setQuery({ ...query, term: searchTerm, size:100, mode: 'forum', slug: forumId, page: 1 })
        }
        fetchData()
    }, [forumId, searchTerm])

    const { isLoggedIn } = useContext(CurrentUser);
    if (!isLoggedIn) {
        return <Unauth/>
    }

    function onBackButton(e) {
        e.preventDefault();
        window.history.back();
    }

    function setFilter(newTerm) {
        setSearchTerm(newTerm);
    }

    return (
        <Container className={`${isLoading ? 'is-loading' : '' } forum-page`}>
            <Row className="topic-header-area">
                <Col className='topic-header'>
                    <div className="button-title-area">
                        <button 
                            type='button'
                            title={document.referrer || 'Go Back'}
                            className="back-button btn btn-norm"
                            onClick={e => onBackButton(e)}
                        >
                            <i className='fa fa-chevron-left'></i>
                        </button>
                        <h3 className='topic-header-text' title={firstPost?.forumName}>{firstPost?.forumName}</h3>
                    </div>
                    <Filter 
                        
                        placeholder="Filter by topics"
                        setFilter={setFilter} 
                        isLoading={isLoading} 
                        historyKey='topic-filter' />
                </Col>
            </Row>
            <Row className="scroll-container-search" ref={scrollPanel}>
                <Col className="scrolled-contents">
                    {
                        isLoading ?
                            <Loading />
                            :
                            rows.map(({ 
                                postSubject,
                                topicId,
                                postTime
                            }, index) => {
                                const date = new Date(postTime * 1000);
                                const formattedDate = date.toDateString();

                                return (
                                    <Card key={`${topicId}${index}`}>
                                        <Card.Body className="topic-body">
                                            <h5>
                                                <a href={`/show-topic/${topicId}`}>
                                                {postSubject}
                                                </a>
                                            </h5>
                                            <span>Last post: {formattedDate}</span>
                                        </Card.Body>
                                    </Card>
                                )
                            })
                    }
                </Col>
            </Row>
            {renderPagination(meta)}
        </Container>
    );

}

export default ForumPage;